exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".basicModal.header{height:36px;background-color:#6be;font-size:14px;font-weight:700;line-height:20px;padding:8px 16px;border-top-left-radius:2px;border-top-right-radius:2px;color:#fff}.basicModal.header .inline-close-button{width:14px;height:14px;position:absolute;right:25px;top:-3px}.basicModal .floating-close-button{position:absolute;top:-35px;right:-35px;cursor:pointer}", ""]);

// exports
